import { Axios } from "api/axios";
import LoaderErrorWrapper from "components/LoaderErrorWrapper/LoaderErrorWrapper";
import LoadSpinner from "components/LoaderErrorWrapper/LoadingSpinner";
import Colors from "Constants/Color";
import { tableStyles } from "Constants/Style";
import { api } from "helpers/api_url";
import React, { Fragment, useEffect, useState } from "react";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import OrderStatusBadge from "components/StatusBadge/OrderStatusBadge";
import FormHeader from "components/Form&DetailsHeader/Form&DetailsHeader";
import TruncatedTextCell from "components/TruncatedTextCell/TruncatedTextCell";
import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ViewBagsModal from "./ViewBagsModal";
import CancelBackButton from "components/Buttons/CancelBackButton";

const ViewOrderDetails: React.FC = () => {
  document.title = "View Order";
  const { id } = useParams();
  const [loading, setLoading] = useState<boolean>(false);
  const [show, setShow] = useState<boolean>(false);
  const [error, setError] = useState<any>("");
  const [data, setData] = useState<any>({});
  const [viewBagsForItem, setViewBagsForItem] = useState<any[]>([]);
  const handleCancel = () => navigate("/inventory-order");

  const navigate = useNavigate();
  useEffect(() => {
    if (id) {
      setLoading(true);
      Axios.get(`${api?.Inventory.order.order_by_id}/${id}`)
        .then((result) => {
          setData(result?.data?.data || {});
        })
        .catch((err) => {
          toast.error("Failed to fetch Order data");
          setError("Failed to fetch Order data");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id]);

  return (
    <Fragment>
      <div
        className="page-content px-4"
        style={{ backgroundColor: "#e9ecef", minHeight: "100vh" }}
      >
        <Container
          fluid
          style={{
            backgroundColor: "#fff",
            padding: "30px",
            borderRadius: "10px",
            boxShadow: "0 0 15px rgba(0,0,0,0.1)",
          }}
        >
          {/* <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2 mb-4">
                        <div className="d-flex align-items-center gap-2">
                            <Link to="/inventory-order" style={{ color: "inherit", textDecoration: "none" }}>
                                <i className="bi bi-arrow-left" style={{ fontSize: "1.2rem", cursor: "pointer" }} aria-label="Back" />
                            </Link>
                            <h6 className="card-title mb-0">View Order</h6>
                        </div>

                        <div className="text-muted">
                            <Link to="/inventory-order" style={{ color: "inherit", textDecoration: "none" }}>
                                Order
                            </Link>{" "}&gt;{" "}
                            <span>View Order</span>
                        </div>
                    </div> */}
          <FormHeader
            title="View Order"
            firstLabel="Order"
            secondLabel="View Order"
            handleArrowClick={handleCancel}
            handleBreadcrumbClick={handleCancel}
          />
          <LoaderErrorWrapper loading={loading} error={error}>
            <div className="mb-2">
              <Row
                className="mb-2"
                style={{ marginLeft: "3px", marginTop: "2px" }}
              >
                <Col xs={12} md={6} lg={4}>
                  <p className="mb-3">
                    <strong>Order No.:</strong> {data?.order_no || "-"}
                  </p>
                </Col>
                <Col xs={12} md={6} lg={4}>
                  <p className="mb-3">
                    <strong>Quotation No.:</strong>{" "}
                    {data?.quotation?.quotation_number || "-"}
                  </p>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <p className="mb-3">
                    <strong>Order Date:</strong>{" "}
                    {data?.order_date?.toString()?.split("T")[0] || "-"}
                  </p>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <p className="mb-3">
                    <strong>Dispatch From Warehouse:</strong>{" "}
                    {data?.warehouse?.warehouse_name || "-"}
                  </p>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <p className="mb-3">
                    <strong>Customer:</strong>{" "}
                    {data?.customer_details?.customer_name || "-"}
                  </p>
                </Col>
              </Row>
            </div>
            <br />
            <div className="mb-3">
              <h6
                className="mb-3"
                style={{ fontWeight: "600", color: "#212529" }}
              >
                Item Details
              </h6>
              <div className="mb-2">
                <Table hover responsive className="align-middle text-center">
                  <thead>
                    <tr>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "80px" }}
                      >
                        Sr No.
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Category
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Sub Category
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Item Name
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Item Code
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Unit
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Quantity
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Bags
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Rate
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Amount
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Discount
                      </th>
                      {/* <th style={{ ...tableStyles.headerAlt, minWidth: "200px" }}>Discount Type</th> */}
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Discount Amount
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        GST%
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        GST Amount
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Total Amount
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Status
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Remarks
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Existing Rows */}
                    {data?.order_items?.length === 0 ? (
                      <tr>
                        <td
                          colSpan={15}
                          style={{ ...tableStyles.cell, textAlign: "center" }}
                          className="py-3"
                        >
                          No Items added. Please add at least one item.
                        </td>
                        <td
                          style={tableStyles.actionCell}
                          className="sticky-column"
                        ></td>
                      </tr>
                    ) : (
                      data?.order_items?.map((row: any, idx: number) => {
                        return (
                          <tr key={idx}>
                            <td style={tableStyles.cell}>{idx + 1}</td>

                            {/* Category */}
                            <td style={tableStyles.cell}>
                              <span>{row?.category?.category_name || "-"}</span>
                            </td>

                            {/* Sub Category */}
                            <td style={tableStyles.cell}>
                              <span>
                                {row?.sub_category?.sub_category_name || "-"}
                              </span>
                            </td>

                            {/* Item Name */}
                            <td style={tableStyles.cell}>
                              <span>{row?.item?.item_name || "-"}</span>
                            </td>

                            {/* Item Code */}
                            <td style={tableStyles.cell}>
                              <span>{row?.item_code || "-"}</span>
                            </td>

                            {/* Unit */}
                            <td style={tableStyles.cell}>
                              <span>
                                {row?.unit?.unit_name || row?.unit || "-"}
                              </span>
                            </td>

                            {/* Quantity */}
                            <td style={tableStyles.cell}>
                              <span>{row?.quantity || "-"}</span>
                            </td>

                            {/* Bags */}
                            <td style={tableStyles.cell}>
                              <div style={{ textAlign: "center" }}>
                                {row?.bags && row.bags.length > 0 ? (
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setViewBagsForItem(row.bags);
                                      setShow(true);
                                    }}
                                    style={{
                                      color: "blue",
                                      cursor: "pointer",
                                      background: "none",
                                      border: "none",
                                      padding: 0,
                                      textDecoration: "underline",
                                    }}
                                  >
                                    View Bags ({row.bags.length})
                                  </button>
                                ) : (
                                  "-"
                                )}
                              </div>
                            </td>

                            {/* Rate */}
                            <td style={tableStyles.cell}>
                              <span>{row?.rate || "-"}</span>
                            </td>

                            {/* Amount */}
                            <td style={tableStyles.cell}>
                              <span>{row.amount || "-"}</span>
                            </td>

                            {/* Discount */}
                            <td style={tableStyles.cell}>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "8px",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <span>{row?.discount || "-"}</span>
                                <span>
                                  {row?.discount_type === "percentage"
                                    ? "%"
                                    : "₹"}
                                </span>
                              </div>
                            </td>

                            {/* Discount Amount */}
                            <td style={tableStyles.cell}>
                              <span>{row.discount_amount || "-"}</span>
                            </td>

                            {/* GST */}
                            <td style={tableStyles.cell}>
                              <span>{row?.gst?.gst_percent || "-"}</span>
                            </td>

                            {/* GST Amount */}
                            <td style={tableStyles.cell}>
                              <span>{row.gst_amount || "-"}</span>
                            </td>

                            {/* Total Amount */}
                            <td style={tableStyles.cell}>
                              <span>{row.total_amount || "-"}</span>
                            </td>

                            {/* Remarks */}
                            <td style={{ ...tableStyles.cell }}>
                              <OrderStatusBadge
                                status={row?.order_item_status || "-"}
                              />
                            </td>

                            <td className="remark-cell" style={tableStyles.cell}>
                              <TruncatedTextCell
                                text={row?.remark}
                                maxWidth="300px"
                                maxLines={4}
                                rowIndex={idx}
                                fallbackText="-"
                              />
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
            <Row className="mb-4">
              <Col lg={7} className="mb-3">
                <div
                  style={{
                    // border: `1px solid ${Colors?.grey}`,
                    borderRadius: "4px 4px 0 0",
                  }}
                >
                  <div
                    className="d-flex align-items-center gap-2 mb-0 py-2 px-1"
                    style={{
                      background: Colors?.grey,
                      borderRadius: "6px 6px 0 0",
                    }}
                  >
                    <i
                      className="bi bi-chevron-down"
                      style={{ fontSize: "0.675rem", color: "#000" }}
                    ></i>
                    <h6 className="mb-0">Remark</h6>
                  </div>
                  <div
                    style={{
                      border: `1px solid ${Colors?.grey}`,
                      borderRadius: "0 0 6px 6px",
                      padding: "12px",
                      minHeight: "167px",
                      height: "100%",
                      backgroundColor: "#fff",
                      color: "#212529",
                    }}
                  >
                    {data.remark}
                  </div>
                </div>
              </Col>
              <Col lg={5} className="mb-3">
                <div
                  style={{
                    backgroundColor: "#e3f2fd",
                    padding: "20px",
                    borderRadius: "8px",
                    border: "1px solid #90caf9",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span style={{ fontSize: "0.875rem", color: "#212529" }}>
                      Subtotal (Before Discount):
                    </span>
                    <span
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "500",
                        color: "#212529",
                      }}
                    >
                      ₹ {Number(data?.subtotal_before_discount)?.toFixed(2)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span style={{ fontSize: "0.875rem", color: "#212529" }}>
                      Total Item Discounts:
                    </span>
                    <span
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "500",
                        color: "#212529",
                      }}
                    >
                      ₹ {Number(data?.total_item_discounts)?.toFixed(2)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span style={{ fontSize: "0.875rem", color: "#212529" }}>
                      Net Taxable Value:
                    </span>
                    <span
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "500",
                        color: "#212529",
                      }}
                    >
                      ₹ {Number(data?.net_taxable_value)?.toFixed(2)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span style={{ fontSize: "0.875rem", color: "#212529" }}>
                      Total GST:
                    </span>
                    <span
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "500",
                        color: "#212529",
                      }}
                    >
                      ₹ {Number(data?.total_gst)?.toFixed(2)}
                    </span>
                  </div>
                  <hr style={{ margin: "12px 0", borderColor: "#90caf9" }} />
                  <div className="d-flex justify-content-between align-items-center">
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "#212529",
                      }}
                    >
                      Total Amount:
                    </span>
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: "700",
                        color: "#212529",
                      }}
                    >
                      ₹ {Number(data?.total_amount)?.toFixed(2)}
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
            <div className="d-flex justify-content-center gap-3 py-3">
              <CancelBackButton to="/inventory-order" label="Back" />
            </div>
          </LoaderErrorWrapper>
        </Container>
      </div>
      <ViewBagsModal
        show={show}
        handleClose={() => setShow(false)}
        bags={viewBagsForItem}
      />
    </Fragment>
  );
};

export default ViewOrderDetails;
